import * as React from 'react';

export interface RadioGroupContextValue {
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeValue?: (newValue: string) => void;
    value?: string | number;
}

export const RadioGroupContext = React.createContext<RadioGroupContextValue | undefined>(undefined);

export function useRadioGroupContext(): RadioGroupContextValue | undefined {
    return React.useContext(RadioGroupContext);
}
